export default __webpack_public_path__ + "static/media/hht1_ep18_minisitcom_03.e82e0fa8.png";